import React from 'react';
import clsx from 'clsx';

const CheckoutItemContainer = ({
  children,
  className,
  checkoutType,
  checkoutLayout,
}) => (
  <div
    className={clsx(className, 'w-full bg-white overflow-hidden', {
      shadow: checkoutType !== 'embed' && checkoutLayout !== 'split',
      'rounded max-w-screen-xs': checkoutType !== 'embed',
    })}
  >
    {children}
  </div>
);

export default CheckoutItemContainer;
